import React, { FC, useEffect } from 'react'
import useLoadingStore from '../../stores/useLoadingStore'

const usePlaygroundLayout = () => {
    const loadingStore = useLoadingStore()

    useEffect(() => {
        loadingStore.setLoading(false)
    }, [])

    return {}
}

export default usePlaygroundLayout
